import { render, staticRenderFns } from "./BaseTextBox.vue?vue&type=template&id=24b7c1f8&scoped=true"
import script from "./BaseTextBox.vue?vue&type=script&lang=ts"
export * from "./BaseTextBox.vue?vue&type=script&lang=ts"
import style0 from "./BaseTextBox.vue?vue&type=style&index=0&id=24b7c1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7c1f8",
  null
  
)

export default component.exports